import { createSelector } from '@reduxjs/toolkit'
import { standardsApi } from 'services/standards.service'

export const selectStandardResult = standardsApi.endpoints.getStandards.select()
export const selectStandards = createSelector(selectStandardResult, (state) => state?.data || [])
